
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FaceTempleteDetail from "./components/face-templete-detail.vue";
import FaceTempleteClass from "./components/face-templete-class.vue";
import PaidParent from "./components/paid-parent.vue";
import PaidRecord from "./components/paid-record.vue";
import { faceTempleteService } from "@/api/payments/faceTempleteService";
import { FaceTempletePaidOrderDetailDto } from "@/api/service-proxies";

@Component({
  components: {
    FaceTempleteDetail,
    FaceTempleteClass,
    PaidParent,
    PaidRecord,
  },
})
export default class OrderDetail extends Vue {
  faceTempleteId!: number;
  faceTempletePaidOrderDetail: FaceTempletePaidOrderDetailDto = null;

  created() {
    this.faceTempleteId = <number>(<unknown>this.$route.params["id"]);

    this.getData();
  }

  getData() {
    faceTempleteService
      .getFaceTempletePaidOrderDetail(this.faceTempleteId)
      .then((result) => {
        this.faceTempletePaidOrderDetail = result;
      });
  }
}
